import React, { useState } from "react";
import { Autocomplete, TextField, Chip } from "@mui/material";
import {produce} from "immer";

const DropdownValuesAutocomplete = ({
                                        id,
                                        formSetter,
                                        disabled,
                                        initialValue,
                                        required, 
                                        onChange,
                                        width
                                    }) => {
    const [value, setValue] = useState(initialValue);
    const [error, setError] = useState(false);

    const handleChange = (e, newValues) => {
        const errorMessage = newValues?.length > 0 ? false : "Please add at least one option." ;
        setValue(newValues);
        setError(errorMessage);
        onChange(!errorMessage);
        formSetter(produce((draft) => {
            draft.enumOptions = newValues;
        }));
    };

    return (
        <Autocomplete
            multiple 
            freeSolo 
            id={`${id}-multi-dropdown`}
            options={[]} 
            disabled={disabled}
            onChange={handleChange}
            value={value} 
            filterSelectedOptions
            sx={{ width: width ??  {xs: '200px !important', sm: '250px !important', md: '300px !important'} }}
            renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                    <Chip
                        variant="outlined"
                        label={option}
                        size="small"
                        {...getTagProps({ index })}
                    />
                ))
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    error={!!error}
                    helperText={error ? error : "Press 'Enter' to add an option."}
                    required={required}
                    label="Options"
                    disabled={disabled}
                    sx={{ width: width ??  {xs: '200px !important', sm: '250px !important', md: '300px !important'} }}
                />
            )}
        />
    );
};

export default DropdownValuesAutocomplete;